import { connect } from 'react-redux';

import { IState } from '../../store/index';
import { IPrintMapProps, PrintMap } from './index';

function mapStateToProps(state: IState): IPrintMapProps {
  return {
    coordinates: state.offerData.offer.geo.coordinates,
    isPrintModeEnabled: state.printModal.isPrintModeEnabled,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PrintMapContainer = connect<IPrintMapProps, any, any>(mapStateToProps)(PrintMap);
